const STORE_ID = "DASHBOARD_ESTEIRA_PRODUCAO";

const TYPES = {
    SET_FILTROS: "SET_FILTROS",
    SET_BIG_NUMBERS: "SET_BIG_NUMBERS",
    SET_BIG_NUMBERS_CANCELADOS: "SET_BIG_NUMBERS_CANCELADOS",
    SET_TABELA_ESTEIRA_PRODUCAO: "SET_TABELA_ESTEIRA_PRODUCAO",
    SET_TABELA_ESTEIRA_PRODUCAO_CANCELADOS: "SET_TABELA_ESTEIRA_PRODUCAO_CANCELADOS",
    SET_INSTITUICOES: "SET_INSTITUICOES",
    SET_LOJAS: "SET_LOJAS",
    SET_MODAL_LOJAS: "SET_MODAL_LOJAS",
    SET_CANAIS: "SET_CANAIS",
    SET_HIERARQUIAS: "SET_HIERARQUIAS",
    SET_GET_ALL_LOJAS: "SET_GET_ALL_LOJAS",
    SET_MODAL_CONSULTORES: "SET_MODAL_CONSULTORES",
    SET_GET_ALL_CONSULTORES: "SET_GET_ALL_CONSULTORES",
    SET_PRODUTOS_RIBER: "SET_PRODUTOS_RIBER",
    SET_TIPOS_OPERACAO: "SET_TIPOS_OPERACAO",
    SET_PARCERIAS: "SET_PARCERIAS",
    SET_CONVENIOS: "SET_CONVENIOS",
    SET_GRUPOS: "SET_ACTIVE_TAB",
    SET_CONSULTORES: "SET_CONSULTORES",
    SET_FILTROS_SELECIONADOS: "SET_FILTROS_SELECIONADOS",
    CLEAN_FILTROS: "CLEAN_FILTROS",
    CLEAN_REGISTER: "CLEAN_REGISTER",
    SET_LOADING_LOJAS: "SET_LOADING_LOJAS",
    SET_LOADING_CONSULTORES: "SET_LOADING_CONSULTORES"
}

export { STORE_ID, TYPES }